import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, MessageCircle, Clock, ThumbsUp } from 'lucide-react';
import api from '../../utils/api';

const IssuesWidget = () => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrending();
  }, []);

  const fetchTrending = async () => {
    try {
      const res = await api.get('/trending-issues?limit=5');
      setIssues(res.data.issues || []);
    } catch (err) {
      console.error('Trending issues error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#111] border border-[#1a1a1a] rounded p-4 mb-4" data-testid="issues-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display text-sm text-[#C5A52A] tracking-wider">THE $HIT LIST</h3>
        <AlertTriangle className="w-4 h-4 text-[#C5A52A]" />
      </div>
      <p className="font-mono text-[10px] text-gray-600 mb-3">Top unresolved issues by engagement</p>

      {loading ? (
        <div className="flex items-center justify-center py-4">
          <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-[#C5A52A]" />
        </div>
      ) : issues.length === 0 ? (
        <p className="font-mono text-xs text-gray-600 text-center py-4">No active issues</p>
      ) : (
        <div className="space-y-2">
          {issues.map((issue) => (
            <div
              key={issue.id}
              className="p-3 rounded bg-[#0a0a0a] border border-[#1a1a1a] hover:border-[#C5A52A]/30 transition-colors"
              data-testid={`issue-item-${issue.id}`}
            >
              <p className="font-mono text-xs text-gray-300 line-clamp-2 mb-2">{issue.content}</p>
              <div className="flex items-center gap-3 text-[10px] font-mono text-gray-600">
                <span className="flex items-center gap-1">
                  <Clock className="w-3 h-3" />{issue.days_outstanding}d
                </span>
                <span className="flex items-center gap-1">
                  <MessageCircle className="w-3 h-3" />{issue.comment_count || 0}
                </span>
                <span className="flex items-center gap-1">
                  <ThumbsUp className="w-3 h-3" />{issue.likes || 0}
                </span>
                {issue.ward && <span className="text-[#C5A52A]">{issue.ward}</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-3 pt-3 border-t border-[#1a1a1a]">
        <Link to="/council" className="block text-center font-mono text-xs text-gray-500 hover:text-[#C5A52A] transition-colors">
          View All Issues
        </Link>
      </div>
    </div>
  );
};

export default IssuesWidget;
